export const heroPicks = [
  {
    id: 1,
    tag: "本期甜口主推",
    title: "海盐焦糖曲奇",
    desc: "黄油底曲奇压入海盐焦糖酱，掰开是微流心的状态，甜度收得住，配无糖茶刚好。",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylized%20flat%20illustration%20of%20a%20round%20sea%20salt%20caramel%20cookie%20broken%20in%20half%20showing%20gooey%20caramel%20center%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20light%20beige%20background%2C%20soft%20grain%20texture%2C%20cheerful%20editorial%20food%20illustration&width=800&height=800&seq=snackbox-pick-cookie-01&orientation=squarish",
  },
  {
    id: 2,
    tag: "本期辣味主推",
    title: "川香麻辣锅巴",
    desc: "米香锅巴裹上青花椒与辣椒面，入口先脆后麻，越嚼越香，是清单里回头率最高的一款。",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylized%20flat%20illustration%20of%20crispy%20rice%20crackers%20coated%20with%20chili%20and%20Sichuan%20pepper%20powder%20in%20a%20small%20ceramic%20dish%2C%20warm%20red%20and%20cream%20tones%2C%20clean%20light%20beige%20background%2C%20soft%20grain%20texture%2C%20editorial%20food%20illustration&width=800&height=800&seq=snackbox-pick-crisps-01&orientation=squarish",
  },
  {
    id: 3,
    tag: "本期坚果主推",
    title: "蜂蜜黄油杏仁",
    desc: "杏仁轻烘后裹一层薄薄的蜂蜜黄油，颗粒分明不粘手，咸甜交织，是随身带的小口粮。",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylized%20flat%20illustration%20of%20honey%20butter%20roasted%20almonds%20scattered%20in%20a%20small%20kraft%20paper%20cup%2C%20warm%20golden%20and%20cream%20tones%2C%20clean%20light%20beige%20background%2C%20soft%20grain%20texture%2C%20editorial%20food%20illustration&width=800&height=800&seq=snackbox-pick-almond-01&orientation=squarish",
  },
];